import { render, staticRenderFns } from "./DepartmentFormModal.vue?vue&type=template&id=6e215bf3&scoped=true"
import script from "./DepartmentFormModal.vue?vue&type=script&lang=js"
export * from "./DepartmentFormModal.vue?vue&type=script&lang=js"
import style0 from "./DepartmentFormModal.vue?vue&type=style&index=0&id=6e215bf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e215bf3",
  null
  
)

export default component.exports